import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getHeaderUserProfile = (data) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.PROFILE.GET_USER_PROFILE(data)
  );
};

export default getHeaderUserProfile;
